export { default } from './ResourceSummaryCard';
